import React from 'react';
import {useHistory, withRouter} from 'react-router-dom';
import moment from 'moment';
import MySwal from "sweetalert2";
import {NotificationManager} from "react-notifications";
import {contactPlayers} from "../../services/matches";
import {useTranslation} from "react-i18next";

// CSS Files
import './styles.css';
import {Col} from "react-bootstrap";

const ScheduleDay = (props) => {
   const history = useHistory();
   const { t } = useTranslation();

   return <Col xs={6} sm={4} className="p-0 schedule-day-wrapper">
      <div className="schedule-day-container">
         {Object.keys(props.timeSlot).map((timeSlot, key) => {
            let formattedDay = moment(timeSlot).utc().format("DD[/]MM[/]YYYY");
            let formattedHour = moment(timeSlot).utc().format("kk[h]mm");

            return <div key={key} className={"hours-container" + (moment(timeSlot).utc().isBefore(moment().utc(), 'day') || props.timeSlot[timeSlot].length === 1 ? " disabled" : "")} onClick={() => {
               MySwal.fire({
                  customClass: {
                     container: 'app-wrapper',
                     input: 'cancel-popup-input',
                     actions: 'cancel-popup-actions',
                  },
                  titleText: t("to_schedule_page.contact_players"),
                  text: t("to_schedule_page.contact_players_popup.verify_proposal", {hour: formattedHour, date: moment(timeSlot).utc().format("dddd[, dia ]DD [de ]MMMM")}),
                  showCancelButton: true,
                  cancelButtonText: t("common.close"),
                  confirmButtonText: t("common.send"),
                  allowEscapeKey: false,
               }).then(async (res) => {
                  if (res.dismiss === MySwal.DismissReason.cancel) {
                     MySwal.close();
                  } else {
                     await contactPlayers(props.matchId, t("to_schedule_page.contact_players_popup.coinciding_availabilities", {day: formattedDay, hour: formattedHour}));
                     try {
                        MySwal.fire({
                           text: t("to_schedule_page.contact_players_popup.success"),
                           allowOutsideClick: false
                        }).then(() => {
                           history.push("/my-games");
                        })
                     } catch (e) {
                        NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
                     }
                  }
               })
            }}>
                  <p>{formattedDay}</p>
                  <p>{formattedHour}</p>
                  <div className="hours-teams">
                     {props.timeSlot[timeSlot].map((team, key) => <div key={key} className={"hour-team-" + team.toLowerCase()}>{team}</div>)}
                  </div>
               </div>
         })}
      </div>
   </Col>
};

export default withRouter(ScheduleDay);
